import type { ChangeEvent, RefObject } from 'react'
import { FormField } from '@/components/ui/form'
import { CloseIcon } from '@/icons'

interface ScreenshotFieldProps {
  screenshot: string | null
  screenshotName: string
  fileInputRef: RefObject<HTMLInputElement | null>
  onSelect: (e: ChangeEvent<HTMLInputElement>) => void
  onRemove: () => void
}

export function ScreenshotField({
  screenshot,
  screenshotName,
  fileInputRef,
  onSelect,
  onRemove,
}: ScreenshotFieldProps) {
  return (
    <FormField label="Screenshot" optional>
      {screenshot ? (
        <div className="flex items-center gap-2 p-2 bg-well rounded-lg">
          <span className="text-sm text-secondary truncate flex-1">{screenshotName}</span>
          <button type="button" onClick={onRemove} className="p-1 text-muted hover:text-primary">
            <CloseIcon className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={onSelect}
          className="text-sm text-secondary file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-well file:text-secondary hover:file:bg-blue-600/20"
        />
      )}
    </FormField>
  )
}
